import { clsx } from "clsx";

import {
  DropdownMenuCheckbox,
  DropdownMenuItem,
} from "common/components/ui/DropdownMenu";

import { LABEL_COLORS } from "../../constants";

import type { Label } from "../../types";

interface LabelsListProps {
  toggleLabel: (label: Label, isSelected: boolean) => void;
  labels: Label[];
  selectedLabels: Label[];
  closePopup: () => void;
}

export default function LabelsList({
  toggleLabel,
  labels,
  selectedLabels,
  closePopup,
}: LabelsListProps) {
  return labels.length ? (
    labels.map((label) => {
      const { id, color, name } = label;
      const isSelected = !!selectedLabels.find(
        (existingLabel) => existingLabel.id === id,
      );
      return (
        <DropdownMenuItem
          key={id}
          onClick={(event) => event.stopPropagation()}
          onSelect={() => {
            toggleLabel(label, isSelected);
            closePopup();
          }}
        >
          <DropdownMenuCheckbox
            isChecked={isSelected}
            onCheckedChange={() => toggleLabel(label, isSelected)}
          />
          <div
            className={clsx(
              "size-3.5 shrink-0 rounded",
              LABEL_COLORS[color].bgClassName,
            )}
          />
          <span className="truncate">{name}</span>
        </DropdownMenuItem>
      );
    })
  ) : (
    <p className="px-4 py-16 text-center text-xs text-black-500">
      You don&apos;t have any labels yet.
      <br /> Start typing to create a label
    </p>
  );
}
